import { useEffect, useState } from "react"
import Header from "../components/Header"
import { Container, Row } from "react-bootstrap";
import { useParams } from "react-router-dom";
import { fetchMemberByQuery } from "../contexts/fetchMemberData";
import { ColMemberDetails, ColMemberImg } from "../components/MemberComp";



const PageMember = () => {

    const { name } = useParams();
    const [data, setData] = useState({})
    useEffect(() => {
        if (!name) return;
        const queryData = async () => {
            const [firstName, lastName] = name?.split('_')
            await fetchMemberByQuery(firstName, lastName, setData)
        }
        queryData()
    }, [name])

    return (
        <>
            <Header />
            <br />
            <Container>
                <Row style={{backgroundColor: 'white', borderRadius: '20px'}}>
                    <ColMemberImg data={data}     />
                    <ColMemberDetails data={data} />
                </Row>

            </Container>
        </>
    )
}

export default PageMember